import React from 'react'
import {Link} from 'react-router-dom'
import CarIcon from '../../../assets/imgs/new-vanshare/car1.svg'
import LocaleText from '../../common/LocaleText'
import {useLocale} from '../../hocs/hooks'
import styles from './HomeStatement.scss'

const HomeStatement = () => {
  const locale = useLocale()
  return <div>
    <div className={['container text-center', styles.container].join(' ')}>
      <div className={['font-italic', styles.title].join(' ')}>
        Stay Anywhere, Anytime.
      </div>
      {/* PC */}
      <div className='d-md-block d-none'>
        <div className={['m-sm-4', styles.text].join(' ')}>
          <LocaleText
            ja="衣食住を詰め込んだ「バン」に乗り込み走り出せば、"
            en="Once you get in the van, packed with food, clothing, and shelter, and start driving."
          /><br />
          <LocaleText
            ja="いつでも、どこでも、好きな人と、好きなことをして"
            en="You can do what you want, with whom you want, anytime, anywhere."
          /><br />
          <LocaleText
            ja="自由な生き方を実現できる、VANLIFE。"
            en="VANLIFE allows you to realize a free way of life."
          />
          <br />
        </div>
        <div className={['mx-3', styles.text].join(' ')}>
          <LocaleText
            ja="Carstayは、誰もがかんたんにVANLIFEを楽しめるよう"
            en="Carstay makes it easy for everyone to enjoy their vanlife."
          />
          <br />
          <LocaleText
            ja="キャンピングカーやバンのカーシェア・レンタル"
            en="Car sharing and rental of campers and vans, and"
          />
          <br />
          <LocaleText
            ja="車中泊用のスペースシェアサービスを展開しています。"
            en="We are developing a space-sharing service for overnight stays in cars."
          />
        </div>
      </div>

      {/* SP */}
      <div className='d-md-none'>
        <div className={['m-sm-4', styles.text].join(' ')}>
          <LocaleText
            ja="衣食住を詰め込んだ「バン」に"
            en="Once you get in the van, packed with food,"
          /><br />
          <LocaleText
            ja="乗り込み走り出せば、"
            en="clothing, and shelter, and start driving."
          /><br />
          <LocaleText
            ja="いつでも、どこでも、好きな人と、"
            en="You can do what you want,"
          /><br />
          <LocaleText
            ja="好きなことをして自由な生き方を実現できる、"
            en="with whom you want, anytime, anywhere."
          />
          <br />
          <LocaleText
            ja="VANLIFE。"
            en="VANLIFE allows you to realize a free way of life."
          />
        </div>
        <div className={['mx-3', styles.text].join(' ')}>
          <LocaleText
            ja="Carstayは、誰もがかんたんに"
            en="Carstay makes it easy for everyone"
          />
          <br />
          <LocaleText
            ja="VANLIFEを楽しめるよう"
            en="to enjoy their vanlife."
          />
          <br />
          <LocaleText
            ja="キャンピングカーやバンの"
            en="Car sharing and rental of"
          />
          <br />
          <LocaleText
            ja="カーシェア・レンタル"
            en="campers and vans, and"
          />
          <br />
          <LocaleText
            ja="車中泊用のスペースシェアサービスを"
            en="We are developing a space-sharing service"
          />
          <br />
          <LocaleText
            ja="展開しています。"
            en="for overnight stays in cars."
          />
        </div>
      </div>

      <Link
        to={`/${locale}/company/`}
        className={['btn btn-primary rounded-pill btn-lg font-weight-bold font-size-15', styles.btn].join(' ')}
      >
        <LocaleText
          ja="会社情報・ニュースリリースはこちら"
          en="Company information and news releases"
        />
      </Link>
    </div>
    <div className={styles.space120}/>
    <div className={[styles.road, 'position-relative'].join(' ')}>
      <div className={[styles.carImg, 'position-relative'].join(' ')}>
        <CarIcon className={styles.carIcon} />
      </div>
    </div>
    
  </div>
}
HomeStatement.displayName = 'Definition'
export default HomeStatement
